import { render, staticRenderFns } from "./CompanyGroupsPage.vue?vue&type=template&id=51c56963&"
import script from "./CompanyGroupsPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyGroupsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyGroupsPage.vue?vue&type=style&index=0&id=51c56963&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports